import { render, staticRenderFns } from "./shang-pin-ling-jian.vue?vue&type=template&id=05b7b3eb&scoped=true"
import script from "./shang-pin-ling-jian.vue?vue&type=script&lang=js"
export * from "./shang-pin-ling-jian.vue?vue&type=script&lang=js"
import style0 from "./shang-pin-ling-jian.vue?vue&type=style&index=0&id=05b7b3eb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b7b3eb",
  null
  
)

export default component.exports